import { useQuery } from '@tanstack/react-query';
import { statisticsApi } from './statisticsApi';
import type { StatsFilters } from '../model/types';

export const statisticsQueryKeys = {
  all: ['statistics'] as const,
  overview: (assistantId: string, filters: StatsFilters) =>
    [...statisticsQueryKeys.all, 'overview', assistantId, filters] as const,
  dialogs: (assistantId: string, filters: StatsFilters) =>
    [...statisticsQueryKeys.all, 'dialogs', assistantId, filters] as const,
  messages: (assistantId: string, dialogId: string) =>
    [...statisticsQueryKeys.all, 'messages', assistantId, dialogId] as const,
};

// Не ретраить на auth-ошибках (как в billing).
const retry = (failureCount: number, error: unknown) => {
  const status = (error as { response?: { status?: number } }).response?.status;
  if (status === 401 || status === 403) return false;
  return failureCount < 1;
};

export function useStatsOverview(assistantId: string, filters: StatsFilters) {
  return useQuery({
    queryKey: statisticsQueryKeys.overview(assistantId, filters),
    queryFn: () => statisticsApi.getOverview(assistantId, filters),
    staleTime: 10_000,
    retry,
  });
}

export function useStatsDialogs(assistantId: string, filters: StatsFilters) {
  return useQuery({
    queryKey: statisticsQueryKeys.dialogs(assistantId, filters),
    queryFn: () => statisticsApi.getDialogs(assistantId, filters),
    staleTime: 10_000,
    retry,
  });
}

/** Переписка одного диалога — грузится только когда dialogId задан (модалка открыта). */
export function useDialogMessages(assistantId: string, dialogId: string | null) {
  return useQuery({
    queryKey: statisticsQueryKeys.messages(assistantId, dialogId ?? ''),
    queryFn: () => statisticsApi.getDialogMessages(assistantId, dialogId as string),
    enabled: !!dialogId,
    staleTime: 10_000,
    retry,
  });
}
